/* import __COLOCATED_TEMPLATE__ from './conversations-link-summary-value.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();